module.exports = __webpack_public_path__ + "static/custom-printing-6ba23e37ead83a675f4c68d464145f9a.jpg";